import axios from 'axios';
import {
  FETCH_STATUS_SUCCESS,
  FETCH_STATUS_FAIL,
  FETCH_MESSAGES_SUCCESS,
  FETCH_MESSAGES_FAIL,
  FETCH_COUNTRIES_BEGIN,
  FETCH_COUNTRIES_SUCCESS,
  FETCH_COUNTRIES_FAIL,
} from './types';

export const fetchStatus = (params) => async (dispatch) => {
  const url = process.env.REACT_APP_API_URL + '/ping/status';
  try {
    const response = await axios.get(url, { params });
    return dispatch({ type: FETCH_STATUS_SUCCESS, payload: response.data.data });
  } catch (error) {
    if (error) {
      return dispatch({ type: FETCH_STATUS_FAIL, errors: error });
    }

    return dispatch({ type: FETCH_STATUS_FAIL });
  }
};

export const fetchMessages = (params) => async (dispatch) => {
  const url = process.env.REACT_APP_API_URL + '/public/messages';
  try {
    const response = await axios.get(url, { params });
    return dispatch({ type: FETCH_MESSAGES_SUCCESS, payload: response.data.data });
  } catch (error) {
    if (error) {
      return dispatch({ type: FETCH_MESSAGES_FAIL, errors: error });
    }

    return dispatch({ type: FETCH_MESSAGES_FAIL });
  }
};

export const fetchCountries = (data) => async (dispatch) => {
  const url = '/countries';
  dispatch({ type: FETCH_COUNTRIES_BEGIN });
  try {
    const response = await axios.get(url, data);
    return dispatch({ type: FETCH_COUNTRIES_SUCCESS, payload: response.data });
  } catch (error) {
    if (error) {
      return dispatch({ type: FETCH_COUNTRIES_FAIL, errors: error });
    }
    return dispatch({ type: FETCH_COUNTRIES_FAIL });
  }
};
